import { Controller } from "@hotwired/stimulus"

// ============================================================
// ClipboardController — 임의의 문자열을 클립보드로 복사
// ============================================================
// 역할: 지갑 주소·TX 해시처럼 손으로 옮겨 적기 어려운 값에 "복사" 버튼을 붙인다.
// 호출처: agents/show 의 슬롯 지갑 카드(주소 복사).
//
// 사용법:
//   <div data-controller="clipboard"
//        data-clipboard-text-value="0x..."
//        data-clipboard-copied-label-value="<%= t('common.copied') %>">
//     <button data-clipboard-target="button" data-action="click->clipboard#copy">복사</button>
//   </div>
//
// 주의사항:
//   - 복사 완료 문구는 i18n 대상이라 뷰가 data-*-copied-label-value 로 내려준다.
//     컨트롤러가 문자열을 갖고 있으면 6개 언어 규칙을 우회하게 된다(하드코딩 금지).
//   - navigator.clipboard 는 보안 컨텍스트(HTTPS·localhost)에서만 동작한다. 미지원·거부 시
//     조용히 원래 라벨을 유지한다(복사 실패로 페이지를 깨뜨리지 않는다).
// ============================================================
export default class extends Controller {
  static targets = ["button"]
  static values = { text: String, copiedLabel: String }

  copy() {
    const text = this.textValue
    if (!text || !navigator.clipboard) return

    navigator.clipboard.writeText(text).then(() => {
      if (!this.hasButtonTarget) return

      const btn = this.buttonTarget
      // 원래 라벨을 보관했다가 2초 뒤 되돌린다(연타해도 "복사됨"이 고착되지 않게).
      if (this._original === undefined) this._original = btn.textContent
      btn.textContent = this.copiedLabelValue || this._original

      clearTimeout(this._timer)
      this._timer = setTimeout(() => {
        btn.textContent = this._original
        this._original = undefined
      }, 2000)
    }).catch(() => {
      // 권한 거부·비보안 컨텍스트 — 사용자는 주소를 직접 선택해 복사할 수 있으므로 무시한다.
    })
  }

  disconnect() {
    clearTimeout(this._timer)
  }
}
